import type { ApiClient } from "../../api/client";
import { desktopApp } from "../../app/desktop";

/**
 * Opens the folder page of the shop in a window of its own (ADR 0050), with a link of 2 hours from the server.
 * `edit`: the page opens in "Bewerken" instead of the print window (the ⚠ button on the sale screen; Furkan,
 * 21/10/2026). The Tafo app for Windows opens the link in Chrome or Edge itself; a browser may block a window
 * opened after the code was typed: then the answer is false and the till says where to find it.
 */
export async function openFolder(api: ApiClient, staffToken: string, edit: boolean): Promise<boolean> {
  const { token } = await api.request<{ token: string; expiresAt: string }>("POST", "/device/folder/link", {
    staffToken,
  });
  const url = new URL(`/folder/${token}${edit ? "?bewerken=1" : ""}`, window.location.origin).href;
  if (desktopApp() !== null) {
    window.open(url, "_blank");
    return true;
  }
  const opened = window.open(url, "_blank");
  if (opened) opened.opener = null;
  return opened !== null;
}
